import { useState } from "react";

import Button, { ButtonProps } from "@/components/atoms/Button";
import Modal from "@/components/molecules/Modal";
import CreateStaticListModal from "@/components/molecules/modals/CreateStaticListModal";

const CreateNewListModalHandler = ({ ...btnProps }: Omit<ButtonProps, "onClick">) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  return (
    <>
      <Button onClick={() => setIsOpened(true)} {...btnProps} />

      <Modal
        isOpen={isOpened}
        onClose={() => setIsOpened(false)}
        content={CreateStaticListModal}
        contentProps={{
          listName: "",
          selectedCompanies: [],
          onSuccess: () => setIsOpened(false),
        }}
      />
    </>
  );
};

export default CreateNewListModalHandler;
